import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { UserRoleName } from '../../core/enums/user-role-name.enum';
import { NavigationService } from '../../core/services/navigation.service';
import { AccessBaseGuard } from './access-base-guard';

@Injectable()
export class AccessManageClientConfigurationsGuard extends AccessBaseGuard {
  protected authService: AuthenticationService;
  protected navigationService: NavigationService;

  constructor() {
    const authService = inject(AuthenticationService);
    const navigationService = inject(NavigationService);

    super(UserRoleName.manageClientConfigurations, authService, navigationService);

    this.authService = authService;
    this.navigationService = navigationService;
  }
}
